import { DataBean } from "../DataBean";

export class TransportDestination extends DataBean {



    public async deleteTransportDestination(idTransportDestination: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteTransportDestination_Number", [idTransportDestination]);
    }

    public async getTransportDestinationCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getTransportDestinationCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}